import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { TransactionsRequest, TransactionsResponse } from '../interfaces/tansactions';

export interface TransactionsState {
  transactions: TransactionsRequest[];
  errorCode: number | null;
  message: string | null;
  processed_transactions: number | null;
}

const initialState: TransactionsState = {
  transactions: [],
  errorCode: null,
  message: null,
  processed_transactions: null
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    getTransactionFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postTransactionsInitApiAction: (state, action: PayloadAction<TransactionsRequest[]>) => {
      state.transactions = action.payload;
    },
    postTransactionsSuccessApiAction: (state, action: PayloadAction<TransactionsResponse>) => {
      state.message = action.payload.message;
      state.processed_transactions = action.payload.processed_transactions
    },
    transactionsClearAction: (state) => {
      state.transactions = [];
      state.errorCode = null;
      state.processed_transactions = null;
      state.message = null;
    },
  },
});

export const {
  getTransactionFailureApiAction,
  postTransactionsInitApiAction,
  postTransactionsSuccessApiAction,
  transactionsClearAction
} = transactionSlice.actions;

export default transactionSlice.reducer;